import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import playstore from "../../assets/Google play.png";
import apple_store from "../../assets/App store.png";
import { EnvironmentOutlined, MailOutlined } from "@ant-design/icons";
import facebook from "../../assets/facebook.png";

const Footer = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);
  const navLinks = [
    { to: "/index", label: "Home" },
    { to: "/index", label: "Introduction" },
  ];

  const subLinks = [
    { to: "/index", label: "- Idioms" },
    { to: "/index", label: "- Metaphors" },
    { to: "/index", label: "- Phrasemes" },
  ];

  const legalLinks = [
    { to: "/terms_and_conditions", label: "Terms and Conditions" },
    { to: "/privacy_policy", label: "Privacy Policy" },
    { to: "/disclaimer", label: "Disclaimer" },
  ];

  return (
    <>
      <footer className={styles.footer}>
        <div className={styles.footer__section}>
          <div className={styles.footer__heading}>Helpful Links</div>

          <div className={styles.footer__list}>
            {navLinks.map((item, index) => (
              <div key={index} className={styles.footer__listItem}>
                <Link
                  className={styles.footer__link}
                  to={item.to}
                  onClick={() => {
                    const scrollContainer = document.querySelector(".pp");
                    if (scrollContainer) {
                      scrollContainer.scrollTo({ top: 0, behavior: "auto" });
                    } else {
                      window.scrollTo({ top: 0, behavior: "auto" });
                    }
                  }}
                >
                  {item.label}
                </Link>
              </div>
            ))}
          </div>

          <div className={styles.footer__list}>
            <div className={styles.footer_list_01}>Figurative Languages :</div>

            {subLinks.map((item, index) => (
              <div key={index} className={styles.footer__listItem}>
                <Link
                  className={styles.footer__link}
                  to={item.to}
                  onClick={() => {
                    const scrollContainer = document.querySelector(".pp");
                    if (scrollContainer) {
                      scrollContainer.scrollTo({ top: 0, behavior: "auto" });
                    } else {
                      window.scrollTo({ top: 0, behavior: "auto" });
                    }
                  }}
                >
                  {item.label}
                </Link>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.footer__section}>
          <div className={styles.footer__heading}>Legal Information</div>

          <div className={styles.footer__list}>
            {legalLinks.map((item, index) => (
              <div key={index} className={styles.footer__listItem}>
                <Link className={styles.footer__link} to={item.to}>
                  {item.label}
                </Link>
              </div>
            ))}
          </div>
        </div>

        <div className={`${styles.footer__section} ${styles.footer__contact}`}>
          <div className={styles.footer__heading}>Contact Us</div>

          <p className={styles.locationBlock}>
            <EnvironmentOutlined className={styles.image_location} />
            <div className={styles.address}>
              230 Victoria Street <br />
              #15-01/08, Bugis Junction Towers <br />
              Singapore - 188024.
            </div>
          </p>

          <p className={styles.footer_email_adjustment}>
            <MailOutlined className={styles.email} />
            <a
              className={`${styles.footer__link} ${styles.footer_email}`}
              href="mailto:sales@cosmicconsultancy.com"
            >
              sales@cosmicconsultancy.com
            </a>
          </p>
        </div>

        <div className={styles.footer__section}>
          <div className={styles.footer__heading}>Get Min Agaram</div>

          <div className={styles.footer__apps}>
            <a
              href="https://apps.apple.com/sg/app/min-agaram/id6483002626"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className={styles.playstore_image}
                src={apple_store}
                alt="App Store"
              />
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.tamil_agarathi_updated"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className={styles.playstore_image1}
                src={playstore}
                alt="Google Play"
              />
            </a>
          </div>

          <div className={styles.footer__heading}>Get Help</div>

          <p>
            <a
              className={styles.footer__link_001}
              href="mailto:support@minagaram.com"
            >
              support@minagaram.com
            </a>
          </p>

          <div className={`${styles.footer__heading} ${styles.new_follow}`}>
            Follow Us
          </div>

          <a
            href="https://www.facebook.com/minagaramfbp/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className={styles.facebook_image}
              src={facebook}
              alt="Facebook"
            />
          </a>
        </div>
      </footer>

      <div className={styles.footer__bottom}>
        <div className={styles.footer__logo}>
          <img
            src="https://tamileagarathi.s3.ap-south-1.amazonaws.com/siteimages/Agarathi.png"
            alt="Logo"
          />
          <strong className={styles.new_minagaram_tittle}>Min Agaram</strong>
        </div>

        <p className={`${styles.new_minagaram_new_one} ${styles.new_abjust}`}>
          © 2024-2026 Cosmic Consultancy Services Pte Ltd. All Rights Reserved.
        </p>
      </div>
    </>
  );
};

export default Footer;
